import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useSupportDiagnosticOptional } from './SupportModeContext';

export const DiagnosticStartDialog: React.FC = () => {
  const ctx = useSupportDiagnosticOptional();
  if (!ctx) return null;
  const open = ctx.phase === 'dialog';

  return (
    <Dialog
      open={open}
      onClose={ctx.closeDialog}
      maxWidth="sm"
      fullWidth
      dir="rtl"
      //* נפתח גם מווידג'ט התמיכה הצף שיושב מעל snackbar — בלי זה הדיאלוג מופיע מאחוריו
      sx={(t) => ({ zIndex: t.zIndex.snackbar + 2 })}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>זיהוי ותיקון תקלות בזמן אמת</DialogTitle>
      <DialogContent>
        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
          נתקלת בבעיה? לחץ על הפעלה, בצע את הפעולה הבעייתית תוך 60 שניות, ואנחנו נקבל דוח טכני מפורט (כולל
          צילומי מסך ולוגים) כדי לפתור אותה עבורך מיד.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1, flexWrap: 'wrap' }}>
        <Button onClick={ctx.closeDialog} color="inherit">
          סגור
        </Button>
        <Button variant="contained" color="primary" onClick={ctx.startRecording}>
          הפעל הקלטה ל-60 שניות
        </Button>
      </DialogActions>
    </Dialog>
  );
};
